import DOMPurify from 'dompurify'

interface SanitizeOptions {
  allowedTags?: string[]
  allowedAttributes?: Record<string, string[]>
  allowedClasses?: Record<string, string[]>
  allowedStyles?: Record<string, Record<string, RegExp[]>>
}

/**
 * A browser-friendly HTML sanitizer that mimics sanitize-html's API
 */
export function sanitizeHtml(dirty: string, options: SanitizeOptions = {}): string {
  if (typeof dirty !== 'string') {
    return ''
  }

  const config: DOMPurify.Config = {
    ALLOWED_TAGS: options.allowedTags || [],
    ALLOWED_ATTR: options.allowedAttributes
      ? Object.entries(options.allowedAttributes).flatMap(([_, attrs]) => attrs)
      : [],
    ADD_ATTR: ['target'],
    ALLOW_DATA_ATTR: false
  }

  return DOMPurify.sanitize(dirty, config)
}

export default sanitizeHtml
